import { Dropdown as EnklaDropdown, ViewHeaderLoader, Explination } from '@enkla-gui'
import { DownOutlined, SettingOutlined } from '@ant-design/icons';
import { Dropdown, Space, Button } from 'antd';
import React, { useEffect } from 'react'
import Tippy from '@tippyjs/react'
export default function ViewHeader(props) {
  useEffect(() => {
    if (props.loading) return
    const override = typeof props.documentTitle === 'string' ? props.documentTitle.trim() : ''
    const fromTitle = typeof props.title === 'string' ? props.title.trim() : ''
    const nextTitle = override || (fromTitle ? `${fromTitle} · Enkla Fastigheter` : '')
    if (!nextTitle) return
    const previousTitle = document.title
    document.title = nextTitle
    return () => {
      document.title = previousTitle
    }
  }, [props.documentTitle, props.title, props.loading])

  function generateBreadcrumbs(crumbs) {
    return crumbs.map((crumb, i) => <li class={`breadcrumb-item ${i === crumbs.length - 1 && 'active'}`}><i class={`fa fas ${crumb.icon} me-1`} aria-hidden="true" /><a href={`${crumb.link}`}>{crumb.title}</a></li>)
  }
  return (
    <div class='component_ViewHeader'>
      {props.loading && <ViewHeaderLoader />}
      {!props.loading && (
        <>
          {(props.return && !props.breadcrumbs) && (
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class={`breadcrumb-item`}><a href={`/`} aria-label="Hem"><i class={`fa fas fa-home me-1`} aria-hidden="true" /></a></li>
                <li class={`breadcrumb-item`}>
                  <a href={`${props.return.link}`}>{props.return.title}</a>
                </li>
              </ol>
            </nav>
          )}
          {props.breadcrumbs &&
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class={`breadcrumb-item`}><a href={`/`} aria-label="Hem"><i class={`fa fas fa-home me-1`} aria-hidden="true" /></a></li>
                {props.return && <li class={`breadcrumb-item`}>
                  <a href={`${props.return.link}`}>{props.return.title}</a>
                </li>}
                {generateBreadcrumbs(props.breadcrumbs)}
              </ol>
            </nav>
          }
          <div class='viewheader-header-container row'>
            <div class='col viewheader-left'>
              {props.icon && <i class={`fas text ${props.icon}`} aria-hidden="true" />}
              <div class='viewheader-text-wrapper'>
                <h1 class='viewheader-title'>{props.title}</h1>
                {props.subtitle && <p class='viewheader-subtitle'>{props.subtitle}</p>}
              </div>
            </div>
            {props.badges && (
              <div class='col-auto viewheader-right'>
                {props.badges.map(badge => {
                  if (React.isValidElement(badge)) {
                    return badge
                  } else {
                    return (
                      <span hidden={badge.hidden} key={`viewheader_badge_${props.badges.indexOf(badge)}`} class={`badge bg-${badge.bg || 'dark'}`}>
                        {badge.icon ? <i class={`${badge.icon} mr-5`} /> : ''} {badge.text}
                        {badge.tip && <Explination tip={badge.tip} />}
                      </span>
                    )
                  }
                })}
              </div>
            )}
          </div>
          {props.buttons && (
            <div class='viewheader-button-container row'>
              <div class='col'>
                <ul>
                  {
                    //chat-gpt-deluxe låt stå
                    (() => {
                      const buttons = props.buttons.filter(b => !b.dropdown);
                      const visibleButtons = buttons.filter(b => !b.hidden);
                      //left?
                      const nonRight = visibleButtons.filter(b => b.position !== 'right');
                      const right = visibleButtons.filter(b => b.position === 'right');
                      const allVisible = [...nonRight, ...right];

                      if (allVisible.length <= 2) {
                        const nonRight = allVisible.filter(b => b.position !== 'right');
                        const right = allVisible.filter(b => b.position === 'right');

                        return (
                          <div class="d-flex">
                            {nonRight.map((button, index) => {
                              const isClickable = button.hasOwnProperty('callback') && !button.loading;
                              const onClick = isClickable
                                ? () => button.callback()
                                : () => (window.location.href = button.href);

                              return (
                                <Button key={`viewheader_button_${index}`} onClick={onClick} disabled={button.disabled} className="me-2">
                                  <Space>
                                    <i
                                      className={`fas fa-fw ${button.loading ? 'fa-circle-notch fa-spin' : button.icon}`}
                                    />
                                    {button.title}
                                    {button.tip && <Explination tip={button.tip} />}
                                  </Space>
                                </Button>
                              );
                            })}
                            {right.length > 0 && (
                              <span className="ms-auto">
                                {right.map((button, index) => {
                                  const isClickable = button.hasOwnProperty('callback') && !button.loading;
                                  const onClick = isClickable
                                    ? () => button.callback()
                                    : () => (window.location.href = button.href);

                                  return (
                                    <Button key={`viewheader_button_right_${index}`} onClick={onClick} disabled={button.disabled} className="me-2">
                                      <Space>
                                        <i
                                          className={`fas fa-fw ${button.loading ? 'fa-circle-notch fa-spin' : button.icon}`}
                                        />
                                        {button.title}
                                        {button.tip && <Explination tip={button.tip} />}
                                      </Space>
                                    </Button>
                                  );
                                })}
                              </span>
                            )}
                          </div>
                        );
                      }

                      const mapButton = (button, prefix, index) => ({
                        key: `${prefix}-${index}`,
                        label: button.title,
                        disabled: button.disabled,
                        extra: button.tip ? <Explination tip={button.tip} /> : "",
                        hidden: button.hidden,
                        onClick:
                          button.hasOwnProperty('callback') && !button.loading
                            ? () => button.callback()
                            : () => (window.location.href = button.href),
                        icon: (
                          <i
                            className={`fas fa-fw ${button.loading ? 'fa-circle-notch fa-spin' : button.icon}`}
                          />
                        ),
                      });
                      //så att radera kommer sist lol
                      right.reverse()

                      const menuItems = right.length > 0 && nonRight.length > 0
                        ? [
                          ...nonRight.map((b, i) => mapButton(b, 'nonRight', i)),
                          { type: 'divider' },
                          ...right.map((b, i) => mapButton(b, 'right', i)),
                        ]
                        : [
                          ...nonRight.map((b, i) => mapButton(b, 'nonRight', i)),
                          ...right.map((b, i) => mapButton(b, 'right', i)),
                        ];
                      if (menuItems.length === 0) return

                      const anyLoading = allVisible.some(b => b.loading)

                      if (props.showButtonsAsRow) {
                        const nonRightButtons = allVisible.filter(b => b.position !== 'right');
                        const rightButtons = allVisible.filter(b => b.position === 'right');

                        return (
                          <div class="d-flex">
                            {nonRightButtons.map((button, index) => {
                              const isClickable = button.hasOwnProperty('callback') && !button.loading;
                              const onClick = isClickable
                                ? () => button.callback()
                                : () => (window.location.href = button.href);

                              return (
                                <Button key={`viewheader_button_${index}`} onClick={onClick} disabled={button.disabled} className="me-2">
                                  <Space>
                                    <i
                                      className={`fas fa-fw ${button.loading ? 'fa-circle-notch fa-spin' : button.icon}`}
                                    />
                                    {button.title}
                                    {button.tip && <Explination tip={button.tip} />}
                                  </Space>
                                </Button>
                              );
                            })}
                            {rightButtons.length > 0 && (
                              <span className="ms-auto">
                                {rightButtons.map((button, index) => {
                                  const isClickable = button.hasOwnProperty('callback') && !button.loading;
                                  const onClick = isClickable
                                    ? () => button.callback()
                                    : () => (window.location.href = button.href);

                                  return (
                                    <Button key={`viewheader_button_right_${index}`} onClick={onClick} disabled={button.disabled} className="me-2">
                                      <Space>
                                        <i
                                          className={`fas fa-fw ${button.loading ? 'fa-circle-notch fa-spin' : button.icon}`}
                                        />
                                        {button.title}
                                        {button.tip && <Explination tip={button.tip} />}
                                      </Space>
                                    </Button>
                                  );
                                })}
                              </span>
                            )}
                          </div>
                        );
                      }

                      return (
                        <Dropdown menu={{ items: menuItems }} disabled={anyLoading}>
                          <Button disabled={anyLoading}>
                            <Space>
                              <i className={`fas fa-fw ${anyLoading ? 'fa-circle-notch fa-spin' : 'fa-tools'}`} />
                              Funktioner
                              <DownOutlined />
                            </Space>
                          </Button>
                        </Dropdown>
                      );
                    })()
                  }
                  {props.buttons.filter(b => b.dropdown && !b.hidden).map((button, index) => (
                    <li key={`viewheader_button_${index}`} class="viewheader-listitem">
                      <Dropdown
                        menu={{
                          items: button.options.map((option, i) => ({
                            key: `${index}-${i}`,
                            label: (
                              <span>
                                {option.icon && <i className={`fas fa-fw ${option.icon}`} />} {option.title}
                              </span>
                            ),
                            disabled: option.disabled,
                            onClick: option.disabled ? undefined : option.callback,
                          })),
                        }}
                      >
                        <Button disabled={button.loading || button.disabled} className={`btn btn-${button.color ?? 'gray'}`}>
                          <Space>
                            {button.loading ? (
                              <i className="fas fa-fw fa-circle-notch fa-spin" />
                            ) : (
                              <i className={`fas fa-fw ${button.icon}`} />
                            )}
                            {button.title}
                            <DownOutlined />
                          </Space>
                        </Button>
                      </Dropdown>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          )}
        </>
      )
      }
    </div >
  )
}
